import { render, staticRenderFns } from "./Hobby.vue?vue&type=template&id=3942513b&scoped=true&"
import script from "./Hobby.vue?vue&type=script&lang=js&"
export * from "./Hobby.vue?vue&type=script&lang=js&"
import style0 from "../index.scss?vue&type=style&index=0&id=3942513b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3942513b",
  null
  
)

export default component.exports